import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

type Crypto = {
  id: string;
  name: string;
  image: string;
  current_price: number;
  price_change_percentage_24h: number;
};

const TableOne: React.FC = () => {
  const [cryptos, setCryptos] = useState<Crypto[]>([]);

  useEffect(() => {
    const fetchCryptoData = async () => {
      try {
        const response = await axios.get(
          'https://api.coingecko.com/api/v3/coins/markets',
          {
            params: {
              vs_currency: 'usd',
              order: 'market_cap_desc',
              per_page: 10,
              page: 1,
              sparkline: false,
            },
          }
        );
        setCryptos(response.data);
      } catch (error) {
        console.error('Error fetching crypto data:', error);
      }
    };

    fetchCryptoData();
  }, []);

  const formatPrice = (price: number) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(price)
      .replace(',', ' ');

  return (
    <div className="w-full px-2 sm:px-6 xl:px-8 py-4 bg-transparent">
      <h4 className="mb-4 text-lg font-semibold text-white sm:mb-6 sm:text-xl">
        Trending Crypto Currencies
      </h4>

      <div className="overflow-x-auto">
        <div className="min-w-full inline-block align-middle">
          {/* Table Header */}
          <div className="grid grid-cols-6 gap-4 text-xs sm:text-sm bg-opacity-10 bg-white text-white font-medium uppercase">
            <div className="p-2 sm:p-3 xl:p-4">#</div>
            <div className="p-2 sm:p-3 xl:p-4">Coin</div>
            <div className="p-2 sm:p-3 xl:p-4 text-center">Name</div>
            <div className="p-2 sm:p-3 xl:p-4 text-center">Price (USD)</div>
            <div className="p-2 sm:p-3 xl:p-4 text-center">24h Change</div>
            <div className="p-2 sm:p-3 xl:p-4 text-center">Buy</div>
          </div>

          {/* Table Rows */}
          {cryptos.map((crypto, index) => (
            <div
              key={crypto.id}
              className="grid grid-cols-6 gap-4 text-xs sm:text-sm items-center transition duration-200 hover:bg-white/10 cursor-pointer border-b border-white/10 text-white"
            >
                <Link
                to={`/coins/${crypto.id}`}
                className="absolute inset-0 z-0"
              />
              <div className="flex items-center justify-center p-2 sm:p-3 xl:p-4">
                {index + 1}
              </div>
              <div className="flex items-center justify-center p-2 sm:p-3 xl:p-4">
                <img
                  src={crypto.image}
                  alt={crypto.name}
                  className="h-6 w-6 sm:h-8 sm:w-8"
                />
              </div>
              <div className="flex items-center justify-center p-2 sm:p-3 xl:p-4">
                <Link
                  to={`/coins/${crypto.id}`}
                  className="hover:underline text-white"
                >
                  {crypto.name}
                </Link>
              </div>
              <div className="flex items-center justify-center p-2 sm:p-3 xl:p-4 whitespace-nowrap">
                {formatPrice(crypto.current_price)}
              </div>
              <div className="flex items-center justify-center p-2 sm:p-3 xl:p-4">
                <p
                  className={
                    crypto.price_change_percentage_24h >= 0
                      ? 'text-green-400'
                      : 'text-red-400'
                  }
                >
                  {crypto.price_change_percentage_24h.toFixed(2)}%
                </p>
              </div>
              <div className="flex items-center justify-center p-2 sm:p-3 xl:p-4">
                <Link
                  to={`/buy/${crypto.id}`}
                  className="bg-blue-600 hover:bg-blue-700 text-white py-1 px-3 rounded text-xs sm:text-sm"
                >
                  Buy
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TableOne;


